<template>
  <div class="error_layout" data-scroll data-scroll-section>
    <Scroll>
      <Header />
      <HeaderScrolled />

      <div class="insurance-description error_page wc-lg">
        <div class="insurance-description__wrapper container flex j_sb">
          <div class="insurance-description__left-col flex column">
            <h3 class="bold f-regular">404</h3>

            <h2 class="f-38 bold uppercase" v-if="windowWidth >= 768">
              {{ $fn.tr("გვერდი ვერ მოიძებნა") }}
            </h2>
            <p class="f-16 regular">{{ $fn.tr("404 გვერდის თიზერ-ტექსტი") }}</p>

            <router-link
              :to="get_home_link"
              class="insurance-description__btn button bg-light-purple wc"
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.351"
                viewBox="0 0 11.352 11.351"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#fff"
                />
              </svg>

              <span class="f-16 bold f-white uppercase">{{
                $fn.tr("მთავარ გვერდზე დაბრუნება")
              }}</span>
            </router-link>
          </div>
          <h2 class="f-38 bold uppercase" v-if="windowWidth <= 767">
            {{ $fn.tr("გვერდი ვერ მოიძებნა") }}
          </h2>

          <div class="insurance-description__right-col">
            <img src="../../assets/imgs/error-page-dude.png" alt="404 page" />
          </div>
        </div>
      </div>
      <Footer />
    </Scroll>
  </div>
</template>


<script>
import Header from "@/components/modules/Header";
import HeaderScrolled from "@/components/modules/HeaderScrolled";
import Footer from "@/components/modules/Footer";
import resize_handler from "@/mixins/resize_handler";

import Scroll from "@/components/Scroll";

export default {
  name: "Error",
  mixins: [resize_handler],

  components: {
    HeaderScrolled,
    Header,
    Footer,
    Scroll,
  },

  mounted() {
    this.$nextTick(() =>
      this.$store.commit("main/setState", {
        key: "trigger_update",
        val: !this.update_trigger,
      })
    );
  },
  computed: {
    update_trigger() {
      return this.$store.state.main.trigger_update;
    },
    get_home_link() {
      return this.$store.state.main.indx.menus.filter((m) => m.set_home == 1)[0]
        .full_url;
    },
  },
};
</script>
<style lang="scss" scoped>
.error_page {
  padding-top: 196px;
}
</style>